var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookIcons = function SvgFacebookIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-icons_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0866FF",
    d: "M32 16c0-8.836-7.163-16-16-16S0 7.164 0 16c0 7.503 5.166 13.8 12.135 15.529v-10.64h-3.3V16h3.3v-2.107c0-5.446 2.465-7.97 7.811-7.97 1.014 0 2.763.2 3.479.398v4.432c-.378-.04-1.034-.06-1.849-.06-2.623 0-3.637.994-3.637 3.578V16h5.226l-.898 4.89H17.94v10.993C25.862 30.926 32.001 24.18 32.001 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.268 20.89.898-4.89h-5.227v-1.73c0-2.583 1.014-3.577 3.637-3.577.815 0 1.471.02 1.849.06V6.32c-.716-.199-2.465-.397-3.479-.397-5.346 0-7.81 2.524-7.81 7.97V16h-3.3v4.89h3.3v10.639a16 16 0 0 0 5.803.354V20.889h4.328"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-icons_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgFacebookIcons;